import {
  coreExtensionData,
  type ExtensionDataValue,
} from '@backstage/frontend-plugin-api';
import apiDocsPluginRoute from '@backstage/plugin-api-docs/alpha';
import techdocsPluginRoute from '@backstage/plugin-techdocs/alpha';
import scaffolderPluginRoute from '@backstage/plugin-scaffolder/alpha';
import {
  OrgSectionLabelProvider,
  type OrgSectionLabelSection,
} from './OrgSectionLabelProvider';

export {
  OrgSectionLabelProvider,
  type OrgSectionLabelSection,
} from './OrgSectionLabelProvider';

/**
 * Reaproveita a saída original da extensão de página, apenas envolvendo o
 * elemento React no OrgSectionLabelProvider com o rótulo contextual da
 * página — assim a página padrão continua intacta e só o rótulo da seção do
 * UserListPicker muda.
 */
const wrapReactElementOutput = (
  output: Iterable<ExtensionDataValue<any, any>>,
  section: OrgSectionLabelSection,
): Array<ExtensionDataValue<any, any>> =>
  Array.from(output).map(value =>
    value.id === coreExtensionData.reactElement.id
      ? coreExtensionData.reactElement(
          <OrgSectionLabelProvider section={section}>
            {value.value}
          </OrgSectionLabelProvider>,
        )
      : value,
  );

/**
 * As páginas de APIs, Documentação e Criar embutem seus próprios
 * UserListPickers, sem ponto de extensão para os filtros (diferente do
 * catálogo, que aceita CatalogFilterBlueprint). Por isso o override é na
 * própria página, preservando o loader original.
 */
export const orgSectionLabelFeatures = [
  apiDocsPluginRoute.withOverrides({
    extensions: [
      apiDocsPluginRoute.getExtension('page:api-docs').override({
        factory: originalFactory =>
          wrapReactElementOutput(originalFactory(), 'apis'),
      }),
    ],
  }),
  techdocsPluginRoute.withOverrides({
    extensions: [
      techdocsPluginRoute.getExtension('page:techdocs').override({
        factory: originalFactory =>
          wrapReactElementOutput(originalFactory(), 'docs'),
      }),
    ],
  }),
  scaffolderPluginRoute.withOverrides({
    extensions: [
      scaffolderPluginRoute.getExtension('page:scaffolder').override({
        factory: originalFactory =>
          wrapReactElementOutput(originalFactory(), 'templates'),
      }),
    ],
  }),
];
